<template>
    <div v-if="currentStage === 'review'" class="byos-review-main-container filter-stage-content pt-5 pt-md-6">
        <div class="review-container byos-content-width px-3">
            <div class="row">
                <div class="gift-img-container col-12 col-md-6">
                    <div class="selected-product-images mr-md-4 mr-lg-6">
                        <div class="d-flex flex-wrap">
                            <div v-for="index in 4" class="image-container ">
                                <div class="media-wrapper ratio-square">
                                    <img v-if="boxProducts[index - 1]" :src="boxProducts[index - 1].image"
                                        :data-product-id="boxProducts[index - 1] ? boxProducts[index - 1].id : ''" class="img-fluid byos-selected-img"
                                        :alt="boxProducts[index - 1].name" />
                                </div>
                            </div> 
                        </div>
                    </div>
                </div>
                <div class="review-products-desc col-12 col-md-6 mt-5 mt-md-0">
                    <h4 class="mb-4" v-html="$t('chooseproducts.boxcontents')"></h4>
                    <div class="box-contents-container products-desc-section">
                        <ByosChoosenProducts />
                    </div>
                    <div class="recipientname-container d-flex justify-content-between py-3">
                        <span class="review-collapsible-heading-content text-uppercase"
                            v-html="`${$t('giftwrapping.review.giftfor')}:`"></span>
                        <span class="reviewvalue recipientname">{{ tagsAndRibbons.name }}</span>
                    </div>
                    <div class="review-ribbon-container d-flex justify-content-between py-3">
                        <span class="review-collapsible-heading-content m-0">
                            <span class="review-collapsible-heading">
                                <span class="review-ribbon-heading text-uppercase"
                                    v-html="`${$t('review.ribboncolor.heading')}:`"></span>
                            </span>
                        </span>
                        <span class="reviewvalue review-ribbon-content" id="reviewRibbonContent">
                            <ul class="list-unstyled mb-0">
                                <li v-html="tagsAndRibbons.color.value" data-ribbon-id=""
                                    data-ribbon-value=""></li>
                            </ul>
                        </span>
                    </div>
                    <div class="review-love-tag-container d-flex justify-content-between py-3">
                        <span class="review-collapsible-heading-content">
                            <span class="review-collapsible-heading review-love-tag-heading text-uppercase"
                                v-html="$t('review.lovetag.heading')">
                            </span>
                        </span>
                        <span class="reviewvalue review-love-tag-content" id="reviewLoveTagContent">
                            <ul class="list-unstyled mb-0">
                                <li v-html="tagsAndRibbons.tag.value" data-tag-id="" data-tag-value=""></li>
                            </ul>
                        </span>
                    </div>
                    <div :class="`review-msg-container py-3 ${tagsAndRibbons.noMessage ? 'd-none' : ''}`">
                        <p class="review-collapsible-heading-content m-0">
                            <a href="#reviewMsgContent" class="review-msg-heading text-uppercase"
                                v-html="`${$t('review.msg.heading')}:`"></a>
                        </p>
                        <div class="reviewvalue review-msg-content" id="reviewMsgContent">
                            <pre class="body-sec">{{ tagsAndRibbons.message.trim() }}</pre>
                        </div>
                    </div>
                    <div class="byos-review-footer review-container-widths">
                        <div class="byos-review-footer-content mx-auto ml-lg-auto mr-lg-0">
                            <p class="sub-total-price text-center mb-4">
                                <span v-html="$t('chooseproducts.subtotal')"></span> <span class="sub-total-value" v-html="subTotalValue"></span>
                            </p>
                            <button
                                data-component="byos/ByosButton"
                                data-step="Step 4: Box it up"
                                @click="wrapByosGift({event: $event})" @keydown.enter.prevent="wrapByosGift({event: $event})" @keydown.space.prevent="wrapByosGift({event: $event})" :class="`btn btn-primary btn-block byos-wrap-my-gift ${boxProducts.length === 0 ? 'disabled' : ''}`" :disabled="boxProducts.length === 0" v-html="$t('byos.review.wrapmygift')"></button>
                            <div class="threshold-qty-msg"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="box-btn-container">
            <div class="byos-content-width px-3">
                <button :aria-label="$t('byos.btn.back.tags')" class="byos-addpersonalmsg" type="button" @click="onSetCurrentStage('tagsAndRibbons')">
                    <span class="icon-chevron">
                        <SvgHelper :icon="'chevron'" :svgtitle="'chevron'" :decorative="true"></SvgHelper>
                    </span>
                    <span v-html="$t('chooseproducts.button.next')"></span>
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
import ByosChoosenProducts from '@/components/byos/ByosChoosenProducts.vue';
import { SvgHelper } from "@/components/helper/util"
import { mapGetters, mapActions } from "@/store/helper/vuex";
const { wrapByosGift, onSetCurrentStage } = mapActions();
const { currentStage, subTotalValue, boxProducts, totalAddedProducts, tagsAndRibbons } = mapGetters();
</script>